var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgCopy = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(7 5)",
  stroke: "#00B177",
  strokeWidth: 1.3
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.65,
  y: 0.65,
  width: 6.2,
  height: 9.1,
  rx: 1.3
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.137 2.6H8.7A1.3 1.3 0 0 1 10 3.9v7.8A1.3 1.3 0 0 1 8.7 13H3.8a1.3 1.3 0 0 1-1.3-1.3v-.462"
})))));

export default SvgCopy;